import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable ,  ReplaySubject,  Subject } from 'rxjs';
import { AbstractCRUD, CRUDService, ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { CapitalAvailable } from '../../shared/models';
import { catchError, tap } from 'rxjs/operators';


/**
 * Singleton service to interact with CapitalAvailable API
 */

@Injectable({
  providedIn: 'root'
})
export class CapitalAvailableService extends AbstractCRUD<CapitalAvailable> implements CRUDService<CapitalAvailable> {
  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService,
  ) {
    super(exceptionService, http, utilsService);
  }

  public getResourcePath(): string {
    return '/portfolio/portfolios/capitalavailable';
  }

  /**
   * Get the Capital Available record.
   */
  public getCapitalAvailable(): Observable<CapitalAvailable> {
    return super.getHTTP()
      .get(this.getApiPath())
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  /**
   * create or update Capital Available record
   */
  public createOrUpdateCapitalAvailable(body: CapitalAvailable): Observable<CapitalAvailable> {
    return super.getHTTP()
      .put(this.getApiPath(), body)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }
}
